import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';
import { getFullname } from 'shared/helpers/common';

const tableHeaderStyle = 'text-[16px] pb-3';

export default function PassengersTableSmallScreen({
  className = '',
  passengerList = [],
}) {
  const { whiteLabelSettings: { primaryColour, secondaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <table className={`${className} table-fixed w-full text-left break-words`}>
      <thead>
        <tr className="text-sm text-gray-500 border-b">
          <th className={`w-[60%] md:w-[65%] ${tableHeaderStyle}`}>
            Passenger
          </th>
          <th className={tableHeaderStyle}>Type</th>
        </tr>
      </thead>
      <tbody>
        {passengerList.map(
          ({ id, title, firstName, middleName, lastName, type, lead }) => (
            <tr key={id} className="border-b text-[16px]">
              <td className="py-3">
                {title} {getFullname({ firstName, middleName, lastName })}
              </td>
              <td className="py-3">
                <div className="flex justify-between">
                  <div>{type}</div>
                  <div>
                    {lead && (
                      <span
                        style={{
                          backgroundColor:
                            secondaryColour || DEFAULT_PRIMARY_COLOUR,
                          color: primaryColour || '#fff',
                        }}
                        className="ml-2 py-1 px-3 text-white text-xs font-medium rounded-[2px]"
                      >
                        LEAD
                      </span>
                    )}
                  </div>
                </div>
              </td>
            </tr>
          ),
        )}
      </tbody>
    </table>
  );
}
